export default "__VITE_ASSET__KarwXeBk__"